import SaveAlt from '@mui/icons-material/SaveAlt'
import { Box } from '@mui/material'
import { selectActiveWorkspace } from 'lib/helpers/selectors'
import { useAppSelector } from 'store/hooks'
import { useCFDIsContainerContext } from 'containers/Invoices/CFDIs/CFDIsContainer/CFDIsContainer'
import Button from 'components/Shared/Button/Button'

const CFDIsTableDownloadOptions = () => {
  const { downloadInvoicesFilesMutation, selectedInvoices, onDownloadCsv } =
    useCFDIsContainerContext()

  const activeWorkspace = useAppSelector(selectActiveWorkspace)

  return (
    <Box
      className="cfdis-table-download-options-component"
      display="flex"
      alignItems="center"
      my={4}
      gap="5rem">
      <Box fontSize="small">
        {selectedInvoices.length > 0
          ? `${selectedInvoices.length} Seleccionad${selectedInvoices.length > 1 ? 'as' : 'a'}`
          : `Selecciona las facturas para descargar la factura o el CSV`}
      </Box>
      {selectedInvoices.length > 0 && (
        <Box display="flex" gap="1.5rem">
          <Button
            id="downloadCfdisBtn"
            variant="outlined"
            color="primary"
            size="large"
            startIcon={<SaveAlt />}
            onClick={() =>
              downloadInvoicesFilesMutation.mutate({
                activeWorkspace,
                selectedInvoices,
              })
            }>
            {`Descargar factur${selectedInvoices.length > 1 ? 'as' : 'a'}`}
          </Button>
          <Button
            id="downloadCfdisCsvBtn"
            variant="contained"
            color="primary"
            size="large"
            startIcon={<SaveAlt />}
            onClick={() => onDownloadCsv(selectedInvoices)}>
            Descargar CSV
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default CFDIsTableDownloadOptions
